import { Button, Container, Stack, Typography } from '@mui/material';
import { captureMessage } from '@sentry/react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { RiveAnimation } from '@frontend/components';
import { tApp, tCommon } from '@frontend/locales';

export const PageNotFoundView = () => {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);

  const message =
    params.get('message') || tApp.errorPages.notFoundDescription();
  const onReturnString = params.get('onReturn');
  const onReturn = onReturnString
    ? Number.parseInt(onReturnString, 10)
    : undefined;

  useEffect(() => {
    captureMessage(`User navigated to a not found page`, 'warning');
  }, []);

  return (
    <Container
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        py: 2,
        width: '100%',
        height: '100%',
      }}
    >
      <Stack justifyContent="center" alignItems="center" maxWidth={430}>
        <RiveAnimation src="/rive/404.riv" height={128} />
        <Stack
          spacing={1}
          mt={3}
          mb={6}
          justifyContent="center"
          alignItems="center"
        >
          <Typography variant="h4">{tApp.errorPages.notFound()}</Typography>
          <Typography variant="body1" color="textSecondary" textAlign="center">
            {message}
          </Typography>
        </Stack>
        {!onReturn && (
          <Button fullWidth variant="contained" onClick={() => navigate(-1)}>
            {tCommon.actions.goBack()}
          </Button>
        )}
        {!!onReturn && (
          <Button
            fullWidth
            variant="contained"
            onClick={() => navigate(onReturn)}
          >
            {tCommon.actions.goBack()}
          </Button>
        )}
      </Stack>
    </Container>
  );
};
